"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateWidget = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const moment_1 = __importDefault(require("moment"));
const textWidget_1 = __importDefault(require("../textWidget"));
const DateWidget = ({ value = '', ...rest }) => (jsx_runtime_1.jsx(textWidget_1.default, Object.assign({ value: value && moment_1.default(value).format('DD / MM / YYYY') }, rest), void 0));
exports.DateWidget = DateWidget;
exports.default = exports.DateWidget;
//# sourceMappingURL=index.js.map